import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createDeleteDeviceDetailedModel } from 'features/delete-device';
import { createEditDeviceDetailedModel } from 'features/edit-device';
import { accountTreeModel } from 'entities/account';
import { createDeviceRegistryModel } from 'entities/device';

const deleteDeviceModel = createDeleteDeviceDetailedModel();

const editDeviceModel = createEditDeviceDetailedModel();

const devicesRegistryModel = createDeviceRegistryModel({
	$currencies: accountTreeModel.$currencies,
	$allAccountIds: accountTreeModel.$nodes.map((nodes) => Object.values(nodes).map(({ id }) => id)),
	onUpdate: [editDeviceModel.editDeviceDetailedMutation.finished.success],
	onDelete: [deleteDeviceModel.mutation.finished.success],
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: devicesRegistryModel.model.filters.accountIds.setValue,
});

chain(devicesRegistryModel.model.clearFilters, accountTreeModel.clearSelectedNodes);

export const devicesPageModel = {
	devicesRegistryModel,
	deleteDeviceModel,
	editDeviceModel,
};
